import { makeStyles, lighten } from "@material-ui/core/styles";

export const SubmitBidContainerStyles = makeStyles(theme => ({
  submitButton: {
    background: theme.palette.common.black,
    "&:hover": {
      background: lighten(theme.palette.common.black, 0.45),
    },
    color: theme.palette.common.white,
    marginTop: "4px",
    padding: "8px",
    borderRadius: "5px",
    width: "100%",
  },
  submitButtonDisabled: {
    background: theme.palette.secondary.dark,
    "&:hover": {
      background: lighten(theme.palette.secondary.dark, 0.45),
    },
    color: theme.palette.secondary.main,
    marginTop: "4px",
    padding: "8px",
    borderRadius: "5px",
    width: "100%",
  },
  formControl: {
    width: "100%",
    paddingBottom: "10px",
    paddingRight: "6px",
    color: theme.palette.common.white,
  },
  padding: {
    padding: "10px",
  },
  submitGrid: { padding: "4px 0 4px 4px" },
}));
